import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'vant/lib/index.css';
import '@/assets/main.css';
import Moment from 'moment';
// import VConsole from 'vconsole/dist/vconsole.min.js'
// let vConsole = new VConsole();

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard);

import {
	Tabbar,
	TabbarItem,
	Toast,
	DropdownMenu,
	DropdownItem,
	Col,
	Row,
	List,
	PullRefresh,
	Icon,
	Cell,
	CellGroup,
	Popup,
	Field,
	Form,
	Search,
	Button,
	Sticky,
	Empty,
	NavBar,
	Switch,
	Dialog,
	Notify,
	Swipe,
	SwipeItem,
	NumberKeyboard,
	Overlay
} from 'vant';

Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(Toast);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Col);
Vue.use(Row);
Vue.use(List);
Vue.use(PullRefresh);
Vue.use(Icon);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Popup);
Vue.use(Field);
Vue.use(Form);
Vue.use(Search);
Vue.use(Button);
Vue.use(Sticky);
Vue.use(Empty);
Vue.use(NavBar);
Vue.use(Switch);
Vue.use(Dialog);
Vue.use(Notify);
Vue.use(NumberKeyboard);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(Overlay);

import FlatList from "@/components/FlatList";
import DropMenu from "@/components/DropMenu";
import BidsItem from "@/components/BidsItem";
import LogButton from "@/components/LogButton";

Vue.component('flat-list', FlatList);
Vue.component('drop-menu', DropMenu);
Vue.component('bids-item', BidsItem);
Vue.component('banner', Banner);
Vue.component('log-button',LogButton);

import Config from './script/config';
import HTTPs from './script/http';
import Utils from './script/utils'
import User from './script/user';
import Banner from "@/components/Banner";
import wx from "weixin-js-sdk";

Vue.prototype.$config = Config;
Vue.prototype.$http = HTTPs;
Vue.prototype.$utils = Utils;
Vue.prototype.$user = User;
Vue.prototype.$moment = Moment;
Vue.prototype.$toast = Toast;
Vue.prototype.$dialog = Dialog;

// initShare(){
// 	let _this = this;
//
//
// }

router.beforeEach((to, from, next) => {
	// if (!Utils.isWx()) {
	// 	Dialog.alert({
	// 		title: '提示',
	// 		message: '请在微信中打开',
	// 	}).then(() => {
	// 	});
	// 	return false;
	// }

	// if (!Utils.isMobile()) {
	// 	Dialog.alert({
	// 		title: '提示',
	// 		message: '请在手机中打开',
	// 	}).then(() => {
	// 	});
	// 	return false;
	// }

	let url = location.href.split('#')[0];
	let _shareurl = 'http://m.clb.org.cn'+to.fullPath;

	let _config = {
		title: '物流招标网', // 分享标题
		link: _shareurl, // 分享链接
		imgUrl: 'http://m.clb.org.cn/images/logo_share.png', // 分享图标
		desc: '欢迎访问物流招标网', // 分享描述
		success () {
			// console.log('fds');
		},
		cancel () {
			// console.log('fds');
		}
	}
	Utils.wxTool(url,function(){
		//分享给朋友
		wx.onMenuShareAppMessage(_config);
		wx.onMenuShareTimeline(_config)
	})

	// if (!User.getOpenid()) {
	//   if (!to.query.code) {
	//     let _url = window.location.href;
	//     let _wxUrl = Utils.getWxCodeUrl(_url);
	//     window.location.replace(_wxUrl);
	//   } else {
	//     // if (!to.query.code) {
	//     //   Dialog.alert({title: '提示', message: '请先获取code'}).then(() => {
	//     //   });
	//     //   return false;
	//     // }
	//
	//     HTTPs.post({
	//       url: 'Common/getOpenid',
	//       data: {code: to.query.code},
	//       success: function (res) {
	//       	if(res.openid) {
	// 	        User.setOpenid(res.openid);
	//         }
	//       }
	//     });
	//   }
	// }

	if(User.getToken()){
		if (to.path === '/login' || to.path === '/register'){
			next({path:'/',query:{...from.query}});
		}else{
			// let toQuery = JSON.parse(JSON.stringify(from.query));

			// console.log(toQuery);

			// let _keys = Object.keys(toQuery);
			//
			// if(_keys.length > 0){
			// 	next({path:to.path,query:{...toQuery}});
			// }else{
				next();
			// }
		}
	}else{
		console.log('path===='+from.path);
		// if (to.path === '/login' || to.path === '/' || to.path === '/register' || to.path === '/about') {
		if (to.path === '/login' || to.path === '/' || to.path === '/register' || to.path === '/order/pay'  || to.path === '/order/pay/' || to.path === '/order/paydone' || to.path === '/vip' || to.path === '/about') {
			next();
		}else{
			Toast({
				message: '请登录',
				position: 'top',
			})
			store.commit('lastPath',to.path);

			// console.log(to.query);
			// console.log('path222===='+to.path);

			next({path:'/login',query:{...to.query}});
		}
	}
});

Vue.config.productionTip = false

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
